import { Adventure } from '@/types/phases';
import { AdventuresTabs } from '../../types';
import { QuestsItem } from '../QuestsItem';
import { ActiveAdventuresPlaceholder } from './Placeholder';

export function ActiveAdventures({ adventures }: { adventures: Adventure[] }) {
  if (adventures.length <= 0) return <ActiveAdventuresPlaceholder />;

  return (
    <div className="quests-adventures">
      {adventures.map(adventure => (
        <QuestsItem
          key={adventure.phase}
          adventure={adventure}
          variant={AdventuresTabs.ActiveAdventures}
        />
      ))}
    </div>
  );
}
